
  export default {
    mounted() {
      // Store the previously focused element
      this.previouslyFocused = document.activeElement

      // Make the body inert to prevent all interactions with elements outside overlay
      document.body.setAttribute("inert", "")

      // Focus the overlay to trap focus
      this.el.focus()

      // Bind event handler
      this.handleKeydown = this.interruptEvent.bind(this)
      // Add listeners in capture phase to intercept before other handlers
      window.addEventListener("keydown", this.interruptEvent, true)
      window.addEventListener("keyup", this.interruptEvent, true)
      window.addEventListener("keypress", this.interruptEvent, true)
    },

    destroyed() {
      // Remove inert attribute
      document.body.removeAttribute("inert")

      // Remove all event listeners
      window.removeEventListener("keydown", this.interruptEvent, true)
      window.removeEventListener("keyup", this.interruptEvent, true)
      window.removeEventListener("keypress", this.interruptEvent, true)

      // Restore focus to the previously focused element
      if (this.previouslyFocused && this.previouslyFocused.focus) {
        this.previouslyFocused.focus()
      }
    },

    interruptEvent(e) {
      // Prevent all interaction while UI is frozen
      e.preventDefault()
      e.stopPropagation()
      e.stopImmediatePropagation()
      return false
    },
  }
